import { call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  fetchMakerCheckerListFail,
  fetchMakerCheckerListSuccess,
  FETCH_MAKER_CHECKER_LIST
} from '../../redux/actions/cm/makerChecker';
import { fetchMakerCheckerList } from '../../services/cm/makerChecker';

function* fetchMakerCheckerListWorker({ filters, currentPage, pageSize }) {
  try {
    const { cases, total } = yield call(fetchMakerCheckerList, {
      filters,
      currentPage,
      pageSize
    });

    yield put(fetchMakerCheckerListSuccess({ cases, total }));
  } catch (error) {
    yield put(fetchMakerCheckerListFail());
  }
}

export function* watchFetchMakerCheckerList() {
  yield takeEvery(
    FETCH_MAKER_CHECKER_LIST,
    function* ({ payload: { filters, currentPage, pageSize } }) {
      yield fork(fetchMakerCheckerListWorker, {
        filters,
        currentPage,
        pageSize
      });
    }
  );
}
